<template>
  <BasePage :pageTitle="__DICT__.menuOptions.Accommodation" show-menu show-footer>
    <Card :title="`${__DICT__.filter} ${__DICT__.menuOptions.Accommodation}`" :show-body="false" margin="mb-4">
      <template #actions>
        <Select v-model="selectedBlock" :options="blockOptions" />
      </template>
    </Card>

    <Card v-for="block in filteredBlocks" :key="block" :title="block" show-status-bar margin="mb-4">
      <template #actions>
        <Badge :text="`${getRoomsForBlock(block).length} rooms`" variant="primary" />
      </template>
      <div class="row g-3">
        <template v-for="room in getRoomsForBlock(block)" :key="room.physical_name">
          <div class="col-auto">
            <span @click="handleRoomClick(room.subblock_id)" class="btn bg-primary-lt cursor-pointer">{{ room.physical_name }}</span>
          </div>
        </template>
      </div>
    </Card>

    <LoadingSpinner v-if="isLoading" :text="__DICT__.loading" />
  </BasePage>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue'
import {useWeekStore} from '@/stores/week.js'
import {usePermissions} from '@/composables/usePermissions'
import {useRouter} from 'vue-router'
import BasePage from "@/components/BasePage.vue"
import { Card, Badge, LoadingSpinner, Select } from "@/components/atomic"

const router = useRouter()
const weekStore = useWeekStore()
const { filter } = usePermissions()
const weekData = ref([])
const isLoading = ref(true)
const selectedBlock = ref('all')

const blockRooms = computed(() => {
  const blocks = {}

  filteredPax.value.forEach(passenger => {
    const accommodation = passenger.allocPlaces?.find(place => place.accommodation)?.accommodation
    if (accommodation) {
      if (!blocks[accommodation.name]) {
        blocks[accommodation.name] = []
      }
      if (!blocks[accommodation.name].find(room => room.subblock_id === accommodation.subblock_id)) {
        blocks[accommodation.name].push({
          physical_name: accommodation.subblock_physical_name,
          subblock_id: accommodation.subblock_id
        })
      }
    }
  })
  return blocks
})

const blocks = computed(() => Object.keys(blockRooms.value).sort())

const blockOptions = computed(() => [
  { value: 'all', label: __DICT__.allBlocks },
  ...blocks.value.map(block => ({ value: block, label: block }))
])


const filteredPax = computed(() => {
  const data = weekData.value || []
  return filter(data, 'viewAllAccommodation')
})

const filteredBlocks = computed(() =>
    selectedBlock.value === 'all' ? blocks.value : [selectedBlock.value]
)

function getRoomsForBlock(blockName) {
  return blockRooms.value[blockName].sort((a, b) => {
    // Helper function to safely extract number and letter
    const parseRoomName = (name) => {
      const match = name.physical_name.match(/(\d+)([a-zA-Z])?/)
      if (!match) return { num: 0, letter: '' } // Default values if no match
      const [_, num, letter = ''] = match
      return { num: parseInt(num), letter }
    }

    const roomA = parseRoomName(a)
    const roomB = parseRoomName(b)

    // First compare by number, then by letter if numbers are equal
    const numDiff = roomA.num - roomB.num
    return numDiff !== 0 ? numDiff : roomA.letter.localeCompare(roomB.letter)
  })
}

function handleBlockClick(block) {
  const rooms = getRoomsForBlock(block)
  if (rooms.length > 0) {
    router.push(`/accommodation/${rooms[0].subblock_id}`)
  }
}

function handleRoomClick(sublockId) {
  router.push(`/accommodation/${sublockId}`)
}

onMounted(() => {
  weekData.value = weekStore.weekData || []
  isLoading.value = !weekStore.weekData
})
</script>